import { useQuery } from '@apollo/client';
import React from 'react';
import Avatar from '../../components/Avatar';
import { gql } from '../../graphql/generated/gql';
import { useGetUser } from '../../user/useAllUsers';
import useIsPublicView from '../../utils/useIsPublicView';

const PUBLIC_USER_QUERY = gql(/** @complexity 2 */ `
  query PublicUserMentionIcon($id: ID!) {
    user: publicUser(id: $id) {
      id
      ...Avatar_user
    }
  }
`);

interface UserMentionIconProps {
  id: string;
}

const UserMentionIcon = ({ id }: UserMentionIconProps) => {
  const getUser = useGetUser();
  const user = getUser({ id });
  const isPublicView = useIsPublicView();

  const { data } = useQuery(PUBLIC_USER_QUERY, {
    variables: { id },
    skip: !isPublicView,
  });

  const publicUser = data?.user;

  return <Avatar user={publicUser ?? user} size="small" />;
};

export default UserMentionIcon;
